export function closeTogglePanel(elements) {
    if (!elements) return;

    function closeParentPanel(submenuEl) {
        const parentWrapper = submenuEl.closest('[data-toggle-panel]');
        if (!parentWrapper) return;

        submenuEl.classList.remove('is-visible');

        const trigger = parentWrapper.querySelector('[data-js="menu-toggle"]');

        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
    }

    function handleToggleClosure(event) {
        event.preventDefault();
        const toggleLink = event.currentTarget;
        const panel = toggleLink.closest('[data-dropdown-panel]');
        if (panel) {
            closeParentPanel(panel);
        }
    }

    elements.forEach((btn) => {
        btn.addEventListener('click', handleToggleClosure);
    });
}